// extracted by mini-css-extract-plugin
export var chip = "_de-0";
export var filterDropdown = "_de-5";
export var filterItem = "_de-6";
export var icon = "_de-1";
export var removeButton = "_de-3";
export var removeIcon = "_de-4";
export var separator = "_de-2";